import config from "../../config"
import RequestService from "../RequestService"

const deleteLaborType = (id, successCallback, failureCallback) => {
  RequestService.delete(`${config.backendUrl}/labor_types/${id}`, successCallback, failureCallback)
}

export default deleteLaborType;